import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {Button, Container, Modal, Text} from "../../../../../components";
import {di} from "../../../../../bottle";


// helper class
class ChangeRequest {

    constructor(changes, callback) {
        this.changes = changes;
        this.callback = callback;
    }
}


// class definition
export class ChangeConfirmation extends PureComponent {

    static propTypes = {
        request: PropTypes.instanceOf(ChangeRequest).isRequired,
        visible: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        visible: false
    };

    static createRequest(changes, callback) {
        return new ChangeRequest(changes, callback);
    }

    constructor(props) {

        // call base constructor
        super(props);

        // set state
        this.state = {};

        // bind methods
        this._onConfirm = this._onConfirm.bind(this);
        this._onCancel = this._onCancel.bind(this);
    }

    render() {

        // resolve input
        const {request, visible} = this.props;
        const {localization} = di;

        const hidePrice = di.profileManager.hidePrice()  

        let changes;
        if (request) {
            // render changes
            changes = request.changes.map((change, index) => {

                let price = '';
                const modelSku = di.garage.bikeModel.sku;
                if(!hidePrice){
                    let modelPrice = di.catalogManager.priceForPart(change.part.sku, modelSku);
                    if (modelPrice != undefined) {
                        price = di.profileManager.localizePrice(modelPrice);
                    } else {
                        price =  di.profileManager.localizePrice(di.catalogManager.priceForPart(change.part.sku));
                    }
                    price = ` (${price})`;
                }

                return (
                    <Text key={`change_${index}`}
                          style={styles.change}
                          bold>
                        {`${localization.get(`build.confirm.${change.operation}`, change.part.name)} ${price}`}
                    </Text>
                );
            });
        }

        // render view
        return (
            <Modal visible={visible}>

                <Text style={styles.title}>{localization.get("build.confirm.title")}</Text>

                <Container>
                    {changes}
                </Container>

                <Container style={styles.buttons}
                           direction="row"
                           justify="space-between"
                           alignContent="space-between">
                    <Button style={styles.buttonWrap} onClick={this._onCancel}>
                        <Text style={styles.button} bold uppercase>{localization.get("build.confirm.cancel")}</Text>
                    </Button>
                    <Button container style={styles.buttonWrap} onClick={this._onConfirm}>
                        <Text style={styles.button} bold uppercase>{localization.get("build.confirm.ok")}</Text>
                    </Button>
                </Container>
        </Modal>
        );
    }

    _onConfirm() {
        this.props.request.callback(true);
    }

    _onCancel() {
        this.props.request.callback(false);
    }
}


// styles
const styles = {
    title: {
        fontSize: 18,
        lineHeight: 1.14,
        color: "#ffffff"
    },
    change: {
        color: "#fff",
        fontSize: 18
    },
    buttons: {
        display: "flex",
    },
    buttonWrap: {
        width: 178,
        height: 42,
        boxShadow: "0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)",
        border: "solid 1px #ffd200",
        backgroundColor: "#333333"
    },
    button: {
        fontSize: 20,
        textAlign: "center",
        color: "#ffffff"
    }
};




// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/ChangeConfirmation.js